export const SMARTPLUG_URL_PARAMS = {
  ORDER: 'order',
  UC_ASSIGNMENT_ID: 'uc_assignment_id',
  UC_BUSINESS_ID: 'uc_business_id',
  UC_CART_ID: 'uc_cart_id',
  UC_CONTEXT: 'uc_context',
  UC_GROUPING_ID: 'uc_grouping_id',
  UC_KARMA: 'uc_karma',
  UC_ORDER_ID: 'uc_order_id',
  UC_SESSION_ID: 'uc_session_id',
  USER_ID: 'user-id',
  UTM_SOURCE: 'utm-source',
  TS: 'ts',
  UC_FLOW_TYPE: 'uc_flow_type',
  FLOW_TYPE: 'flow_type',
  UC_TICKET_ID: 'uc_ticket_id',
};

export const DASHBOARD_MODE = {
  SMARTPLUG: 'smartplug',
};

export const OSBizIDOrgIDMap = {
  2: 1, // Blinkit
  13: 4, // Bistro
};
